import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class Intro extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        const { content } = this.props;

        return (
            <div id="introduction" className={styles.introduce}>
                <div className={styles.pic}>
                    <img src={content.introPic} />
                </div>
                <p>{content.paragraph1}</p>
                <p>{content.paragraph2}</p>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
Intro.propTypes = { content: PropTypes.object };

/**
 * 定义组件默认属性
 * */
Intro.defaultProps = {};

export default Intro;
